export const contactContent = {
  title: 'Contact Me',
  glowColor: '#FF5252',
  intro:
    'If you have any thoughts or comments about me or my work, feel free to reach out via email or LinkedIn!',
};
